import { render, staticRenderFns } from "./BodyBold.vue?vue&type=template&id=d7ee8070&scoped=true"
import script from "./BodyBold.vue?vue&type=script&lang=js"
export * from "./BodyBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ee8070",
  null
  
)

export default component.exports